import Api from '~/store/idonia-api/api'

const state = {
  value: 0
}

const mutations = {
  setValue (state, value) {
    state.value = value
  }
}

const actions = {
  loadElements ({commit, state}) {
    var params = {}
    if (state.guestAuth) {
      params.headers = {
        Authorization: state.guestAuth
      }
    }

    return Api.getV2('files/deleted/count', params).then(response => {
      commit('setValue', response.body || 0)
      commit('trash/totalElementsCount', response.body || 0, { root: true })
      return response
    })
  },
  checkDescendantsExceeds ({commit, state}, {ids = []} = {ids: []}) {
    let params = {
      data: {
        files: ids
      }
    }
    if (state.guestAuth) {
      return Promise.resolve()
    }

    return Api.postV2('files/deleted/check-descendants', params).then(response => {
      return response.body ? { exceeds: response.body.exceeds_caution, limit: response.body.limit } : false
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/files/trash/count.js